'use strict';

const base = require('base/addressBook/addressBook');
const formValidation = require('base/components/formValidation');
const Recaptcha = require('../util/recaptcha');

/**
 * Gets the correct zipcode error message based on selected country
 * @param {string} country - country code of the requested error message
 */
function getValidationErrorMessage(country) {
    var url = $('#zipCode').data('url-errormsg'); // Address-ZipcodeValidation
    $.ajax({
        url: url,
        method: 'GET',
        dataType: 'json',
        data: {
            countryCode: country
        },
        success: function (data) {
            if (data && data.errorMessage) {
                $('#zipCode').data('pattern-mismatch', data.errorMessage);
            }
        }
    });
}

/**
 * Retrieves the country and the patterns for postal code from the isml and sets a pattern for the postal code
 */
function assignPostalCodePattern() {
    var postalCodesPatterns = $('#zipCode').data('postal-codes-patterns');
    var country = $('#country').val() || $('#country option').val();

    if (postalCodesPatterns && country) {
        $('#zipCode').attr('pattern', postalCodesPatterns[country]);
        getValidationErrorMessage(country.toLowerCase());
    }
}

module.exports = $.extend({}, base, {
    assignPostalCodePattern: assignPostalCodePattern,
    changePostalCodePattern: () => {
        $('#country').on('change', assignPostalCodePattern);
    },
    submitAddress: function () {
        $('form.address-form').submit(function (e) {
            var $form = $(this);
            e.preventDefault();
            const url = $form.attr('action');
            $form.spinner().start();
            $('form.address-form').trigger('address:submit', e);
            Recaptcha.generateToken('address_saveaddress').then(function (token) {
                var requestData = $form.serialize();
                requestData += '&g-recaptcha-response=' + token;
                $.ajax({
                    url: url,
                    type: 'post',
                    dataType: 'json',
                    data: requestData,
                    success: function (data) {
                        $form.spinner().stop();
                        if (!data.success) {
                            formValidation($form, data);
                        } else {
                            location.href = data.redirectUrl;
                        }
                    },
                    error: function (err) {
                        if (err.responseJSON.redirectUrl) {
                            window.location.href = err.responseJSON.redirectUrl;
                        }
                        $form.spinner().stop();
                    }
                });
                return false;
            });
        });
    }
});
